module.exports = __webpack_public_path__ + "static/media/font_regular.d1d871be.woff";